import * as React from "react";
import Icon13 from "../img/7481d4f175f497fa3ca635d9ea8974d559a00bf54762cdfe73ec49ac971c04f3.svg";
function SearchBar() {
  return (
    /*<form className="flex gap-2.5 items-center px-5 py-3 text-lg font-light bg-stone-50 rounded-[31px] text-zinc-500">
      <img
        loading="lazy"
        src={Icon13}
        className="object-contain shrink-0 self-stretch my-auto aspect-square w-[27px]"
        alt=""
      />
      <label htmlFor="librarySearch" className="sr-only">Search this library</label>
      <input
        type="search"
        id="librarySearch"
        placeholder="Search this library"
        className="bg-transparent border-none outline-none w-[380px]"
      />
    </form>*/
    null
  );
}

export default SearchBar;